<template>
  <div class="p-payg-invoice-modal__plan-details">
    <ElTable
      id="invoiceTable"
      v-loading="!items.length"
      :data="items">
      <ElTableColumn
        :label="$t('companySettings.billing.invoicePreview.item')">
        <template slot-scope="scope">
            <span>{{ scope.row.description }}</span>
        </template>
      </ElTableColumn>
      <ElTableColumn
        align="right"
        :label="$t('companySettings.billing.invoicePreview.value')">
        <template slot-scope="scope">
            <span>{{ $n(parseFloat(scope.row.price / 100), 'currency', scope.row.currency ? scope.row.currency : preview.currency) }}</span>
        </template>
      </ElTableColumn>
    </ElTable>
  </div>
</template>

<script>

export default {
  name: 'VInvoicePreviewTable',
  props: {
    preview: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
};

</script>
